import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILikedType } from "src/types/GlobalInterfaces";
export type InitialState =
  | "pharmacyDisLike"
  | "doctorDisLike"
  | "testsDisLike"
  | "packageDisLike"
  | "homecareDisLike"
  | "diagnosticProductDisLike";
// Initial state of the dis like slice
export const initialState: {
  pharmacyDisLike: string[];
  doctorDisLike: string[];
  testsDisLike: string[];
  packageDisLike: string[];
  homecareDisLike: string[];
  diagnosticProductDisLike: string[];
  dislikeItem: {
    id: string;
    type: ILikedType | "";
  };
} = {
  pharmacyDisLike: [],
  doctorDisLike: [],
  testsDisLike: [],
  packageDisLike: [],
  homecareDisLike: [],
  diagnosticProductDisLike: [],
  dislikeItem: {
    id: "",
    type: "",
  },
};

// Create the dis like slice
export const disLike = createSlice({
  name: "DIS_LIKE_SLICE",
  initialState,
  reducers: {
    removeAllDisLike: (state, action: PayloadAction<InitialState>) => {
      state[action.payload] = [];
    },
    updateDisLike: (
      state,
      action: PayloadAction<{ key: InitialState; value: string }>
    ) => {
      state[action.payload.key] = [
        ...state[action.payload.key],
        action.payload.value,
      ] as string[];
    },
    removeDisLike: (
      state,
      action: PayloadAction<{ key: InitialState; value: string }>
    ) => {
      state[action.payload.key] = state[action.payload.key].filter(
        (v) => v !== action.payload.value
      ) as string[];
    },
    updateDisLikeItem: (
      state,
      action: PayloadAction<{ id: string; type: ILikedType | "" }>
    ) => {
      state.dislikeItem = action.payload;
    },
  },
});
export const { updateDisLike, removeAllDisLike, removeDisLike, updateDisLikeItem } =
  disLike.actions;
// Export action creators

// Export the reducer to be used in the store
export default disLike.reducer;
